import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  Input
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, delay, take, filter } from 'rxjs/operators';
import { RxDrug, Drug } from '@care-portals/api-interfaces';
import { DrugFacade } from '../../../+store/drug/drug.facade';
import { FormsModule } from '@angular/forms';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { CommonModule } from '@angular/common';
import { NzTagModule } from 'ng-zorro-antd/tag';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzAutocompleteModule,
    NzButtonModule,
    NzTagModule
  ],
  selector: 'portals-emr-drug-selector',
  templateUrl: './drug-selector.component.html',
  styleUrls: ['./drug-selector.component.less']
})
export class DrugSelectorComponent implements OnInit, OnDestroy {
  @Input() addButton: boolean;
  @Output() drugSelected: EventEmitter<RxDrug> = new EventEmitter();
  @Output() drugAdded: EventEmitter<RxDrug> = new EventEmitter();
  drugs: Drug[];
  filteredDrugs: Drug[];
  keyword = '';
  isDestroyed = new Subject();
  selectedDrug: RxDrug;

  constructor(private drugFacade: DrugFacade) {
    this.drugFacade.allDrug$
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(res => {
        this.drugs = res;
        this.filteredDrugs = this.drugs;
      });
  }

  ngOnInit() {
    if (this.drugs?.length) {
      return;
    }

    this.drugFacade.allDrug$
      .pipe(
        delay(300),
        take(1),
        takeUntil(this.isDestroyed)
      )
      .subscribe(drugs => {
        if (!drugs?.length) {
          this.drugFacade.loadDrugs({ status: 'active' });
        }
      });
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }

  onChange(e: Event): void {
    const value = (e.target as HTMLInputElement).value;
    this.filteredDrugs = this.drugs.filter(drug =>
      drug.name.toLowerCase().includes(value.toLowerCase())
    );
  }

  fieldSelected(event, drug: Drug): void {
    if (event.isUserInput) {
      this.selectedDrug = {
        din: drug.din,
        drugName: drug.name,
        refills: drug.refills || 0,
        mitteType: drug.mitteType,
        options: drug.options,
        mitte: drug.mitte,
        notes: drug.sig
      } as RxDrug;
      this.drugSelected.emit(this.selectedDrug);
    }
  }

  onAddDrugClick() {
    if (this.selectedDrug) {
      this.drugAdded.emit(this.selectedDrug);
    }
    this.selectedDrug = null;
  }

  clearKeyword(): void {
    this.keyword = '';
    this.filteredDrugs = this.drugs;
  }
}
